//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiResult } from '../nswag/nswag-base-class';
import { NSwagBaseClassDataHub } from '../nswag/nswag-base-class-datahub';
import { NSwagBaseClassDataService } from '../nswag/nswag-base-class-dataservice';

export class DataSourceService extends NSwagBaseClassDataService {
    private baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return Success
     */
    getById(id: string): Promise<ApiResult<SourceConfigurationDto>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return Success
     */
    delete(id: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.process("DELETE", url_, options_);
    }

        /**
     * @return Success
     */
    getByName(name: string): Promise<ApiResult<SourceConfigurationDto>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param tags (optional) 
     * @return Success
     */
    getAll(tags: string[] | undefined): Promise<ApiResult<SourceConfigurationListItemDto[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources?";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @return Success
     */
    create(body: SourceConfigurationDto): Promise<ApiResult<SourceConfigurationDto>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return Success
     */
    update(body: UpdateSourceConfigurationDto): Promise<ApiResult<SourceConfigurationDto>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("PUT", url_, options_);
    }

        /**
     * @return Success
     */
    trigger(dataSourceId: string): Promise<ApiResult<void>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{dataSourceId}/trigger";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return Success
     */
    getTags(): Promise<ApiResult<string[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param body (optional) 
     * @param formFile (optional) 
     * @return Success
     */
    uploadFile(body: Body | undefined, formFile: FileParameter | undefined): Promise<ApiResult<UploadFileToAzureBlobStorageResponse>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return Success
     */
    getHistory(dataSourceId: string): Promise<ApiResult<SourceConfigurationHistoryDto[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{dataSourceId}/history";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }

        /**
     * @param originalHistoryId (optional) 
     * @return Success
     */
    getHistoryComparison(dataSourceId: string, originalHistoryId: string | undefined, modifiedHistoryId: string): Promise<ApiResult<SourceConfigurationHistoryComparisonDto>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/DataSources/{dataSourceId}/history/compare?";
        if (dataSourceId === undefined || dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' must be defined.");
        url_ = url_.replace("{dataSourceId}", encodeURIComponent("" + dataSourceId));
        if (originalHistoryId === null)
            throw new Error("The parameter 'originalHistoryId' cannot be null.");
        else if (originalHistoryId !== undefined)
            url_ += "originalHistoryId=" + encodeURIComponent("" + originalHistoryId) + "&";
        if (modifiedHistoryId === undefined || modifiedHistoryId === null)
            throw new Error("The parameter 'modifiedHistoryId' must be defined and cannot be null.");
        else
            url_ += "modifiedHistoryId=" + encodeURIComponent("" + modifiedHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export class SchemaService extends NSwagBaseClassDataService {
    private baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @param body (optional) 
     * @param csvFile (optional) 
     * @param delimiter (optional) 
     * @return Success
     */
    generateSchemaFromCsvFile(body: Body2 | undefined, csvFile: FileParameter | undefined, delimiter: string | undefined): Promise<ApiResult<SchemaElementDto[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/Schema/generate-from-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");
        if (delimiter === null || delimiter === undefined)
            throw new Error("The parameter 'delimiter' cannot be null.");
        else
            content_.append("Delimiter", delimiter.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }
}

export class SearchService extends NSwagBaseClassDataService {
    private baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * Returns data from given data source by provided search criteria
     * @return Success
     */
    search(body: SearchQueryDto): Promise<ApiResult<SearchResult[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }

        /**
     * @return Success
     */
    batchSearch(body: MultiSearchQueryDto): Promise<ApiResult<MultiSearchResult[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/Search/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.process("POST", url_, options_);
    }
}

export class TenantsService extends NSwagBaseClassDataService {
    private baseUrl: string;

    constructor() {
        super();
        this.baseUrl = ""; // FRISS: this is set NSwagBaseClass and read from runtime_config.js
    }

        /**
     * @return Success
     */
    getTenants(): Promise<ApiResult<TenantDto[]>> {
        let url_ = this.baseUrl + "/api/v1/dataservice/Tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.process("GET", url_, options_);
    }
}

export interface FileSourceDto {
    password: string | null;
}

export interface AzureBlobStorageFileSourceDto extends FileSourceDto {
    blobName: string;
}

export interface PolymorphicRootDto {
}

export interface IngestionSettingDto extends PolymorphicRootDto {
    readonly type: IngestionType;
}

export interface AzureBlobStorageIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    connectionString: string;
    containerName: string;
    fileSources: AzureBlobStorageFileSourceDto[];
}

export interface DataFormatSettingDto extends PolymorphicRootDto {
    readonly type: DataFormatType;
}

export interface CsvDataFormatSettingDto extends DataFormatSettingDto {
    readonly type: DataFormatType;
    hasHeader: boolean | null;
    delimiter: string | null;
}

export interface CustomIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    ingestionSettings: { [key: string]: IngestionSettingDto; };
    customIngestionType: CustomIngestionType;
}

export enum CustomIngestionType {
    ETars = "ETars",
}

export enum DataFormatType {
    Xml = "Xml",
    Json = "Json",
    Csv = "Csv",
    Excel = "Excel",
}

export interface DatahubIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    dataProviderId: string;
    dataSourceId: string;
    tenantId: string;
}

export interface DownloadSettingDto {
    ingestionSetting: IngestionSettingDto;
    dataFormatSetting: DataFormatSettingDto;
    ingestionIndexingSetting: IngestionIndexingSettingDto;
}

export interface ExcelDataFormatSettingDto extends DataFormatSettingDto {
    readonly type: DataFormatType;
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };
}

export interface IngestionIndexingSettingDto {
    objectId: string | null;
    useAppend: boolean;
}

export enum IngestionType {
    Url = "Url",
    SFTP = "SFTP",
    AzureBlobStorage = "AzureBlobStorage",
    ManualFileUpload = "ManualFileUpload",
    Datahub = "Datahub",
    Custom = "Custom",
}

export interface JsonDataFormatSettingDto extends DataFormatSettingDto {
    elementPath: string | null;
    readonly type: DataFormatType;
}

export interface LocalFileSourceDto extends FileSourceDto {
    location: string;
}

export interface ManualFileUploadIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    azureBlobStorageIngestionSetting: AzureBlobStorageIngestionSettingDto | null;
    fileSources: ManuallyUpdatedFileSourceDto[];
}

export interface ManuallyUpdatedFileSourceDto extends FileSourceDto {
    fileName: string;
    blobName: string;
}

export enum MatchingItemType {
    Other = "Other",
    Filter = "Filter",
    PersonFullName = "PersonFullName",
    PersonLastName = "PersonLastName",
    PersonNamePrefix = "PersonNamePrefix",
    PersonFirstName = "PersonFirstName",
    PersonInitials = "PersonInitials",
    PersonInitial = "PersonInitial",
    PersonGender = "PersonGender",
    PersonDob = "PersonDob",
    CompanyName = "CompanyName",
    CompanyCocNumber = "CompanyCocNumber",
    AddressStreet = "AddressStreet",
    AddressHousenumber = "AddressHousenumber",
    AddressHousenumberAddition = "AddressHousenumberAddition",
    AddressPostalcode = "AddressPostalcode",
    AddressCity = "AddressCity",
    AddressCountry = "AddressCountry",
    ObjectTelephoneNumber = "ObjectTelephoneNumber",
    ObjectEmailAddress = "ObjectEmailAddress",
    ObjectBankaccountNumber = "ObjectBankaccountNumber",
    IPAddress = "IPAddress",
    DeviceId = "DeviceId",
}

export interface MultiSearchQueryDto {
    source: string;
    mapping: string | null;
    searchRequests: SearchRequestDto[];
    size: number;
}

export interface MultiSearchResult {
    results: SearchResult[];
}

export interface NotificationSettingDto {
    email: string;
    onSuccess: boolean;
    onFailure: boolean;
}

export interface RestrictionSettingsDto {
    allowedTenants: string[];
}

export interface SchemaElementDto {
    elementName: string;
    schema: SchemaElementDto[] | null;
}

export interface SchemaElementMappingDto {
    sourcePath: string;
    destinationPath: string;
}

export interface SchemaMappingDto {
    type: string;
    mappings: SchemaElementMappingDto[];
}

export interface SearchFieldDto {
    path: string;
    query: string;
    fuzzyMatch: boolean;
    threshold: number | null;
    matchType: MatchingItemType | null;
}

export enum SearchMode {
    And = "And",
    Or = "Or",
}

export interface SearchQueryDto {
    source: string;
    mapping: string | null;
    searchFields: SearchFieldDto[];
    size: number;
    searchMode: SearchMode;
    sort: SortDto[] | null;
}

export interface SearchRequestDto {
    searchFields: SearchFieldDto[];
    searchMode: SearchMode;
    sort: SortDto[] | null;
}

export interface SearchResult {
    scores: { [key: string]: number; };
    source: { [key: string]: any; };
}

export interface SftpIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    host: string;
    port: number;
    username: string;
    password: string;
    fileSources: LocalFileSourceDto[];
}

export interface SortDto {
    path: string;
    order: SortOrderType;
}

export enum SortOrderType {
    Asc = "Asc",
    Desc = "Desc",
}

export interface SourceConfigurationDto {
    id: string | null;
    name: string;
    description: string | null;
    restrictionSetting: RestrictionSettingsDto | null;
    notificationSettings: NotificationSettingDto[];
    downloadSetting: DownloadSettingDto;
    cronExpression: string;
    secureStringContainer: { [key: string]: string; };
    schema: SchemaElementDto[] | null;
    mappings: SchemaMappingDto[] | null;
    tags: string[];
}

export interface SourceConfigurationHistoryComparisonDto {
    originalJson: string | null;
    modifiedJson: string;
}

export interface SourceConfigurationHistoryDto {
    historyEntryId: string;
    sourceConfigurationId: string;
    timestamp: string;
    commentMessage: string | null;
    user: string;
}

export interface SourceConfigurationListItemDto {
    id: string;
    name: string;
    description: string | null;
    isPublic: boolean;
    cronExpression: string;
    lastExecution: string | null;
    lastState: string | null;
    nextExecution: string | null;
    lastJobId: string | null;
    isLastJobExpired: boolean | null;
    tags: string[];
    ingestionType: IngestionType;
    mappingTypes: string[];
}

export interface TenantDto {
    tenantId: string;
    tenantName: string;
}

export interface UpdateSourceConfigurationDto extends SourceConfigurationDto {
    commentMessage: string | null;
}

export interface UploadFileToAzureBlobStorageResponse {
    azureBlobStorageName: string;
}

export interface UrlFileSourceDto extends FileSourceDto {
    url: string;
}

export interface UrlIngestionSettingDto extends IngestionSettingDto {
    readonly type: IngestionType;
    fileSources: UrlFileSourceDto[];
}

export interface XmlDataFormatSettingDto extends DataFormatSettingDto {
    readonly type: DataFormatType;
    collectionElementName: string;
}

export interface Body {
    FormFile: string;
}

export interface Body2 {
    CsvFile: string;
    Delimiter: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}